import { useQuery } from "@tanstack/react-query";

import { getUnreadMessageCount } from "../queryFunctions/getUnreadMessageCount";
import { messagingKeys } from "../keyFactory";

const isPollingEnabled = process.env.REACT_APP_ENABLE_MESSAGE_NOTIFICATIONS_UPDATE === "true";
const pollingInterval = parseInt(
  process.env.REACT_APP_ENABLE_MESSAGE_NOTIFICATIONS_UPDATE_REFRESH_TIME ?? "0",
  10,
);

export function useUnreadMessageCount({ isEnabled = true }: { isEnabled?: boolean } = {}) {
  const refetchInterval = isPollingEnabled && pollingInterval > 0 ? pollingInterval : false;

  return useQuery({
    enabled: isEnabled,
    queryFn: getUnreadMessageCount,
    queryKey: messagingKeys.count(),
    refetchInterval,
    refetchIntervalInBackground: false,
  });
}
